import React from 'react';
import { RadioButton } from '@progress/kendo-react-inputs';
import { useTranslation } from 'react-i18next';

const NumberTypeField = ({ value, onChange, disabled }) => {
    const { t } = useTranslation([
        "attribute/number_type",
    ], {
        useSuspense: false
    })
    return (
        <div>
            <span className="me-4 spacer">
                <RadioButton
                    checked={value === "integer"}
                    value="integer"
                    label={t("integer")}
                    onChange={onChange}
                    disabled={disabled} />
            </span>
            <span className="me-2">
                <RadioButton
                    checked={value === "decimal"}
                    value="decimal"
                    label={t("decimal")}
                    onChange={onChange}
                    disabled={disabled} />
            </span>
        </div>
    );
};

export default NumberTypeField;
